// --- Our Modules --------------------------------------------------------------------------------
import constants from "@/config/constants";
import useOrganization from "@/hooks/useOrganization";
// --- Logic --------------------------------------------------------------------------------------
/**
 * Role-based, and nothing about it is configurable. There are no permission arrays in this product:
 * owners and managers reach every section, a member reaches everything but the restricted list — which
 * mirrors the backend's `CLIENT_SUPER_MODELS`.
 *
 * Hiding a section is not security. The API refuses it too.
 */
export default function usePermission() {
    const role = useOrganization((state) => state.role);

    const isOwner = role === "owner";
    const isManager = role === "manager";
    const isMember = role === "member";

    const canAccess = (model: string): boolean => {
        if (!role) return false;
        if (isMember) return !constants.superModels.includes(model);
        return true;
    };

    return { role, isOwner, isManager, isMember, canAccess };
}
